import { Column } from "../../../../core/components/Column";
import { CustomButton } from "../../../../core/components/CustomButton";
import { TextComponent } from "../../../../core/components/TextComponent";
import { HiddenLikePreview } from "../../../match/domain/entities/likesYou";
import { ProtectedLikeThumbnail } from "./ProtectedLikeThumbnail";

export const HiddenLikesPreview = ({
	count,
	likes,
	onSubscribe,
	canLoadMore = false,
	loadingMore = false,
	onLoadMore = () => {},
}: {
	count: number;
	likes: HiddenLikePreview[];
	onSubscribe: () => void;
	canLoadMore?: boolean;
	loadingMore?: boolean;
	onLoadMore?: () => void;
}) => {
	const likeLabel = count === 1 ? "person liked" : "people liked";

	return (
		<Column className="gap-5" crossAxisAlignment="center">
			<div className="w-full rounded-2xl border border-[#F4B8E5] bg-gradient-to-br from-[#FFF2FB] to-white px-5 py-6 text-center shadow-sm">
				<TextComponent variant="h4" className="font-bold text-primary">
					{count} {likeLabel} your profile
				</TextComponent>
				<TextComponent variant="h6" className="mt-2">
					Subscribe to see everyone who likes you. You can still match and chat for free in Discovery.
				</TextComponent>
			</div>
			{likes.length > 0 && (
				<div className="grid w-full grid-cols-1 gap-3 lg:grid-cols-2" aria-label="Protected hidden likes">
					{likes.map((like, index) => (
						<button
							key={index}
							type="button"
							onClick={onSubscribe}
							aria-label={`Protected like ${index + 1}. Subscribe to reveal.`}
							className="group flex min-h-28 w-full items-center gap-4 rounded-2xl border border-gray-200 bg-white p-3 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-primary hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
						>
							<ProtectedLikeThumbnail thumbnailUrl={like.thumbnail_url} />
							<div className="min-w-0 flex-1">
								<p className="text-base font-bold text-gray-900">Someone likes you</p>
								<p className="mt-1 text-sm leading-5 text-graySecondary">
									Keep browsing Discovery. If you like each other, you will match and chat for free.
								</p>
							</div>
							<svg className="h-6 w-6 shrink-0 text-primary" viewBox="0 0 24 24" fill="none" aria-hidden="true">
								<path d="M7 10V8a5 5 0 0 1 10 0v2m-9 0h8a2 2 0 0 1 2 2v7H6v-7a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</button>
					))}
				</div>
			)}
			{canLoadMore && (
				<button
					type="button"
					onClick={onLoadMore}
					disabled={loadingMore}
					className="font-semibold text-primary underline-offset-4 hover:underline disabled:opacity-50"
				>
					{loadingMore ? "Loading more likes..." : "Show more protected likes"}
				</button>
			)}
			<CustomButton type="button" onClick={onSubscribe} className="w-full md:w-auto md:min-w-80">
				Subscribe to reveal who likes you
			</CustomButton>
		</Column>
	);
};
